import * as React from "react";
import { Button as Button$1 } from "@grandvisionhq/common";
import { compose } from "@grandvisionhq/utils";
/* empty css            */
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
const CmsButton = ({ component, page }) => {
  const { document: documentRef } = component.getModels();
  const document = documentRef && page.getContent(documentRef);
  if (!document) {
    return null;
  }
  const { buttonStyling, contentType, displayName, iconImage, newWindow, url } = document.getData();
  const hrefTarget = newWindow ? "_blank" : "_self";
  if (!url || !displayName) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: "br-button", "data-t": "br-button" }, /* @__PURE__ */ React.createElement(
    Button$1,
    {
      caption: displayName,
      color: buttonStyling,
      icon: iconImage,
      href: url,
      hrefTarget,
      type: contentType
    }
  ));
};
const Button = compose(
  withBreakpointVisibility,
  withEditableContent,
  withAnchor
)(CmsButton);
export {
  CmsButton,
  Button as default
};
//# sourceMappingURL=Button.js.map
